export const Theme = {
    planeColor: 0x90909,
    gridColor: 0x434343,
    selectorColor: 0x15cf5f
};
